// Shapes a guest from the booked-room state into the guest_details entry the
// booked-room PUT expects. user_id is forwarded when the guest is already
// linked to an Alfred account; otherwise the backend links them by contact.
export function buildGuestPayload(guest) {
    if (guest.is_minor) {
        return {
            name: guest.name,
            is_minor: true,
            verification_id: "",
            manual_verification: false,
            email: "",
            address: "",
        };
    }

    const payload = {
        name: guest.name,
        contact: guest.contact,
        email: guest.email || "",
        address: guest.address || "",
        verification_id: guest.verification_id || "",
        manual_verification: guest.manual_verification || false,
        is_minor: false,
    };

    if (guest.user_id) {
        payload.user_id = guest.user_id;
    }

    return payload;
}
